import axios from 'axios';
import { translateApiError } from '../i18n/LocaleContext';

// 后端报错原文是越南语,在错误出口统一替换成当前界面语言的文案。
// 未知消息原样透出(行为与改动前一致),不影响未接入映射的接口。
let installed = false;

export const installApiErrorTranslator = () => {
  if (installed) return;
  installed = true;
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const message = error.response?.data?.error;
      if (typeof message === 'string' && message) {
        // 保留越南语原文,供按原文判断分支的代码使用(如余额不足判断)
        error.response.data.errorVi = message;
        error.response.data.error = translateApiError(message);
      }
      return Promise.reject(error);
    }
  );
};
